import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { IProfile } from '../shared/interfaces/profile';
import { ProfileService } from '../shared/services/profile.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  city: string;
  btnMenuClass = '';
  btnMenuState = false;

  constructor(
    private router: Router, 
    private location: Location,
    private profileService: ProfileService) {
  }

  ngOnInit(): void {
    let profile: IProfile = this.profileService.getProfile();
    this.city = profile.address.rawCity;
    let fullPath = this.router.url.split('/');
    let page = fullPath[2];

    this.scroll(page);
  }

  onBtnMenuClick() {
    this.btnMenuState = !this.btnMenuState;
  }

  setMenuClass() {
    return {
      'menu': true,
      'open': this.btnMenuState
    };
  }

  scroll(page: string) {
    let target: string;

    switch (page) {
      case "consultas-e-exames":
        target = "treatment";
        break;

      case "curriculo":
        target = "profile";
        break;

      case "atendimento":
        target = "address";
        break;

      case "agendar":
        target = "schedule";
        break;

      default:
        break;
    }

    if (target == undefined)
      return;

    this.location.go(`${this.city}/${page}`);

    setTimeout(() => {
      this.onBtnMenuClick();
      document.getElementById(target).scrollIntoView({ behavior: 'smooth' });
    }, 10);
  }

}